import { render } from "./LandingPatioCover.vue?vue&type=template&id=2096378a&scoped=true"
import script from "./LandingPatioCover.vue?vue&type=script&lang=js"
export * from "./LandingPatioCover.vue?vue&type=script&lang=js"

import "./LandingPatioCover.vue?vue&type=style&index=0&id=2096378a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2096378a"]])

export default __exports__